import { Container, Row, Col, Card, Button } from "react-bootstrap"
import productbanner from "../assets/productsec/productbanner.jpg";

import { Link } from "react-router-dom"
import "../pages/styled/Product.css"
import p1 from "../assets/SSP/Y3.png";
import p2 from "../assets/SSP/B8.png";
import p3 from "../assets/SSP/p1.png";
import p4 from "../assets/SSP/B9.png";
import p5 from "../assets/SSP/W4.png";
import p6 from "../assets/SSP/PW1.png";
import p7 from "../assets/SSP/FC1.jpeg";
import p8 from "../assets/SSP/TIC1.jpeg";
import p9 from "../assets/SSP/FF1.jpeg";
import p10 from "../assets/SSP/Tissuepaper.jpg";
import p11 from "../assets/SSP/Dustbin.jpeg";
import p12 from "../assets/SSP/Softbroom.jpeg";
import p13 from "../assets/SSP/Coconut.jpeg";
import p14 from "../assets/SSP/Toiletbrush.jpeg";
import p15 from "../assets/SSP/Yellowcloth.jpeg"; 
import p16 from "../assets/SSP/Napthalin.jpeg";
import p17 from "../assets/SSP/Microcloth.jpg";
import p18 from "../assets/SSP/Urinalpad.jpeg";
import p19 from "../assets/SSP/Urinalcube.jpeg";
import p20 from "../assets/SSP/Mop1.jpeg";
import p21 from "../assets/SSP/Odonilairpocket.jpeg";
import p22 from "../assets/SSP/Tissueroll.jpeg";
import p23 from "../assets/SSP/Blichingpowder.jpeg";
import p24 from "../assets/SSP/Drumcleaner.jpeg";
import p25 from "../assets/SSP/Sinkcleaner.jpeg";
import p26 from "../assets/SSP/Acid.jpeg";
// Housekeeping product images (placeholders)
const productImages = [
p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,p15,p16,p17,p18,p19,p20,p21,p22,p23,p24,p25,p26
]

function ProductPage() {
  // Housekeeping products data
  const products = [
    {
      id: 1,
      title: "Floor Cleaner",
      description: "Effectively removes stains and dirt, leaving your floors spotless and fresh.",
      image: productImages[0],
      category: "Surface Cleaners",
      quantity:'500ml',
      price: "₹90",
    },
    {
      id: 2,
      title: "Dish Wash",
      description: "Tough on grease, gentle on hands, ensuring sparkling clean dishes.",
      image: productImages[1],
      category: "Dishwashing",
      quantity:'500ml',
      price:'₹90',
    },
    {
      id: 3,
      title: "Hand Wash",
      description: "Kills germs while keeping your hands soft and moisturized.",
      image: productImages[2],
      category: "Personal Hygiene",
      quantity:'250ml',
      price:'₹100',
    },
    {
      id: 4,
      title: "Glass Cleaner",
      description: "Streak-free formula for crystal-clear windows and mirrors.",
      image: productImages[3],
      category: "Glass & Mirror Cleaners",
      quantity:'500ml',
      price:'₹100',
    },
    {
      id: 5,
      title: "Liquid Detergent",
      description: "Deep cleans clothes while being gentle on fabrics.",
      image: productImages[4],
      category: "Laundry Care",
      quantity:'250ml',
      price:'₹100',
    },
    {
      id: 6,
      title: "Room Freshener",
      description: "Eliminates odors and fills your space with a refreshing fragrance.",
      image: productImages[5],
      category: "Air Fresheners",
      quantity:'250ml',
      price:'₹120',
    },
    {
      id: 7,
      title: "Toilet Cleaner",
      description: "Removes tough stains, kills germs, and leaves your toilet sparkling clean.",
      image: productImages[6],
      category: "Bathroom Cleaners",
      quantity:'500ml',
      price:'₹90',
    },
    {
      id: 8,
      title: "Tiles Cleaner",
      description: "Effectively removes stains, grime, and dirt from tiles, restoring their shine.",
      image: productImages[7],
      category: "Surface Cleaners",
      quantity:'650ml',
      price:'₹130',
    },
    {
      id: 9,
      title: "Fabric Freshener",
      description: "Keeps fabrics smelling fresh and removes unwanted odors.",
      image: productImages[8],
      category: "Laundry Care",
      quantity:'650ml',
      price:'₹120',
    },
    {
      id: 10,
      title: "Tissue Paper",
      description: "Soft and absorbent tissue paper for everyday use.",
      image: productImages[9],
      category: "Paper Products",
      quantity:'1No',
      price:'₹40',
    },
    {
      id: 11,
      title: "Dustbin Cover (S, M, L, XL)",
      description: "Durable covers to keep your dustbin clean and hygienic.",
      image: productImages[10],
      category: "Waste Management",
      quantity:'1NO',
      rate:'₹60',
    },
    {
      id: 12,
      title: "Soft Broom",
      description: "Lightweight and efficient broom for dusting floors.",
      image: productImages[11],
      category: "Cleaning Tools",
      quantity:'1No',
      price:'₹120',
    },
    {
      id: 13,
      title: "Coconut Broom",
      description: "Traditional coconut broom for tough outdoor cleaning.",
      image: productImages[12],
      category: "Cleaning Tools",
      quantity:'1No',
      price:'₹55',
    },
    {
      id: 14,
      title: "Toilet Cleaning Brush",
      description: "Designed for deep cleaning of toilet bowls.",
      image: productImages[13],
      category: "Bathroom Cleaners",
      quantity:'1No',
      price:'₹90',
    },
    {
      id: 15,
      title: "Yellow Cloth",
      description: "Multipurpose cleaning cloth for dusting and wiping.",
      image: productImages[14],
      category: "Cleaning Accessories",
      quantity:'1No',
      price:'₹10',
    },
    {
      id: 16,
      title: "Naphthalene Balls",
      description: "Protects clothes from insects and bad odors.",
      image: productImages[15],
      category: "Pest Control",
      quantity:'1/2kg',
      price:'₹90',
    },
    {
      id: 17,
      title: "Microfiber Cloth",
      description: "Ultra-soft and highly absorbent cloth for cleaning surfaces.",
      image: productImages[16],
      category: "Cleaning Accessories",
      quantity:'1No',
      price:'₹65',
    },
    {
      id: 18,
      title: "Urinal Pad",
      description: "Keeps urinals fresh and prevents bad odors.",
      image: productImages[17],
      category: "Bathroom Maintenance",
      quantity:'1poc',
      price:'₹80',
    },
    {
      id: 19,
      title: "Urinal Cube",
      description: "Keeps urinals fresh and prevents bad odors.",
      image: productImages[18],
      category: "Bathroom Maintenance",
      quantity:'1poc',
      price:'₹60',
    },
    {
      id: 20,
      title: "Mop",
      description: "Highly absorbent mop for easy floor cleaning.",
      image: productImages[19],
      category: "Cleaning Tools",
      quantity:'1No',
      price:'₹100',
    },

    {
      id: 21,
      title: "Odonil Air Pocket",
      description: "Air freshener pocket for lasting freshness in rooms and bathrooms.",
      image: productImages[20],
      category: "Air Fresheners",
      quantity:'1No',
      price:'₹50',
    },
    {
      id: 22,
      title: "Tissue Roll",
      description: "Soft and absorbent tissue roll for daily use.",
      image: productImages[21],
      category: "Paper Products",
      quantity:'1No',
      price:'₹60',
    },
    {
      id: 23,
      title: "Bleaching Powder",
      description: "Multipurpose disinfectant for cleaning and stain removal.",
      image: productImages[22],
      category: "Disinfectants",
      quantity:'1kg',
      price:'₹40',
    },
    {
      id: 24,
      title: "IFB Washing Machine Drum Cleaner",
      description: "Removes dirt and residue from washing machine drums.",
      image: productImages[23],
      category: "Appliance Cleaners",
      quantity:'1poc',
      price:'₹150',
    },
    {
      id: 25,
      title: "Sink Cleaner",
      description: "Removes clogs and keeps sinks clean and fresh.",
      image: productImages[24],
      category: "Kitchen Cleaners",
      quantity:'1poc',
      price:'₹28',
    },
    {
      id: 26,
      title: "Acid",
      description: "Strong cleaner for removing stubborn stains and deposits.",
      image: productImages[25],
      category: "Heavy-Duty Cleaners",
      quantity:'1L',
      price:'₹25',
    }
];

  return (
    <>
      {/* Hero Banner with PRODUCTS text */}
      <div
  className="contact-header"
  style={{
    backgroundImage: `url(${productbanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  }}
>
  <div className="header-content">
    <h1
      className="header-title"
      style={{
        fontSize: "3rem",
        fontWeight: "bold",
        color: "#fff",
        textTransform: "uppercase",
      }}
    >
      PRODUCT
    </h1>
  </div>
</div>

      <section className="productpage-section py-5">
        <Container>
          <div className="text-center mb-5">
            <span className="productpage-subtitle">Premium Products</span>
            <h2 className="productpage-header">Professional Cleaning & Maintenance</h2>
            <div className="productpage-title-underline"></div>
            <p className="productpage-description">
              Discover our innovative housekeeping products designed for superior cleanliness.
            </p>
          </div>
          <Row>
            {products.map((product) => (
              <Col lg={4} md={6} sm={6} xs={12} className="mb-4" key={product.id}>
                <Card className="productpage-card h-100">
                  <div className="productpage-img-container">
                    <Card.Img variant="top" src={product.image} className="productpage-img" />
                    <div className="productpage-category">{product.category}</div>
                  </div>
                  <Card.Body className="bg-secondary">
                    <Card.Title className="productpage-title">{product.title}</Card.Title>
                    <Card.Text className="productpage-text">{product.description}</Card.Text>
                    {/* <Card.Text className="productpage-text text-dark"><span>Quantity :{product.quantity}</span></Card.Text> */}
                    <Card.Text className="productpage-text-price"><span>Price :<span className="text-price-value">{product.price}</span></span></Card.Text>
                  </Card.Body>
                  <Card.Footer className="border-0 pb-4 text-center bg-secondary">
                    {/* Link to product detail page with product ID */}
                    <Link to={`/product/${product.id}`}>
                      <Button variant="primary" className="productpage-read-more-btn">
                       BUy Now
                      </Button>
                    </Link>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  )
}

export default ProductPage
